import { AppSidebar } from "@/components/sidebar/app-sidebar-user";
import { ProtectedRoute } from "@/components/protected-route";
import { NotFoundInLayout } from "@/components/reusable-components/not-found";
import { SidebarProvider } from "@/components/ui/sidebar";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useCommandMenuShortcut } from "@/hooks/use-command-menu-shortcut";
import { CommandMenu } from "@/components/command-menu";
import { useAuthStore } from "@/stores/useAuthStore";
import { useEffect } from "react";
import { auth } from "@/lib/auth";
import { useOrganizationStore } from "@/stores/useOrganizationStore";
import { useFeatureStore } from "@/stores/useFeatureStore";
import { useOrgSettingsStore } from "@/stores/useOrgSettingsStore";

export const Route = createFileRoute("/user/_layout")({
  beforeLoad: async () => {
    await useFeatureStore.getState().fetchFeatures();
    await useOrgSettingsStore.getState().fetchSettings();
  },
  component: UserDashboard,
  notFoundComponent: NotFoundInLayout,
});

function UserDashboard() {
  const { organizationTimezone, fetchTimezone, isLoading, error } =
    useOrganizationStore();

  useEffect(() => {
    if (!organizationTimezone && !isLoading && !error) {
      fetchTimezone();
    }
  }, [organizationTimezone, fetchTimezone, isLoading, error]);
  const { getProfile, user } = useAuthStore();

  useEffect(() => {
    const token = auth.getToken();
    if (token && !user) {
      getProfile();
    }
  }, [getProfile, user]);
  useCommandMenuShortcut();
  return (
    // The baseline. Own records, own requests — everyone has it, no
    // permission grants it and no role can remove it.
    <ProtectedRoute redirectTo="/login">
      <SidebarProvider>
        <AppSidebar />
        <CommandMenu />
        <Outlet />
      </SidebarProvider>
    </ProtectedRoute>
  );
}
